import React from 'react';
import { Dropdown } from 'react-bootstrap';

/**
 * CustomDropdown - A wrapper around React Bootstrap's Dropdown component
 * This component has been refactored to leverage React Bootstrap's Dropdown component
 * instead of implementing a custom dropdown from scratch.
 * 
 * @param {Object} props Component props
 * @param {React.ReactNode} props.children Dropdown menu items
 * @param {string} props.title Dropdown toggle text
 * @param {string} props.className Optional additional classes
 * @param {boolean} props.show Control dropdown visibility externally
 * @param {function} props.onToggle Callback when dropdown visibility changes
 * @returns {React.ReactElement} A Bootstrap Dropdown component
 */
const CustomDropdown = ({ 
  children, 
  title, 
  className = '', 
  show, 
  onToggle,
  alignRight = false
}) => {
  return (
    <Dropdown 
      as="li"
      className={`custom-dropdown ${className}`}
      show={show}
      onToggle={onToggle}
      align={alignRight ? "end" : "start"}
    >
      <Dropdown.Toggle as="a" className="nav-link" id={`dropdown-${title.replace(/\s+/g, '-').toLowerCase()}`}>
        {title}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-custom">
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomDropdown;